/* eslint-disable @next/next/no-before-interactive-script-outside-document */
/* eslint-disable @next/next/no-sync-scripts */
import Script from 'next/script';
import dynamic from 'next/dynamic';
import Fonts from '../components/atoms/Fonts/Fonts';
import GlobalStyles from '../components/atoms/Reset/GlobalStyles';
import { LoadingProvider } from '../utils/loading';
import ResetCSS from '../components/atoms/Reset/ResetCSS';

const EnergiaSolarProvider = dynamic(
  () =>
    import('../modules/simulador-energia-solar/widgets/SimuladorSolarProvider').then(
      (mod) => mod.SimuladorSolarProvider,
    ),
  {
    ssr: true,
  },
);

function MyApp({ Component, pageProps }) {
  return (
    <LoadingProvider>
      {pageProps?.energiaSolar ? (
        <EnergiaSolarProvider>
          <Component {...pageProps} />
        </EnergiaSolarProvider>
      ) : (
        <Component {...pageProps} />
      )}

      <Fonts subPage={pageProps && pageProps.importPrefix === '../'} />
      <GlobalStyles />

      <>
        <wpc-mfe-cookies-element id="mfe">
          <link rel="stylesheet" href="https://www.santander.com.br/mfe-cookies/styles.css" />
          <script src="https://www.santander.com.br/mfe-cookies/polyfills.js" />
          <script src="https://www.santander.com.br/mfe-cookies/main.js" />
        </wpc-mfe-cookies-element>

        <Script
          id="verify-iframes"
          async
          strategy="beforeInteractive"
          dangerouslySetInnerHTML={{
            __html: `
var evalIframe = function (iframe) {
  if (/^_hj/.test(iframe.id) || /creativecdn|doubleclick|prddir/.test(iframe.src)) {
    iframe.setAttribute('aria-hidden', 'true');
    iframe.setAttribute('title', 'IFrame');
  }
};
// avalia os iframes no carregamento da página
var iframes = document.querySelectorAll('iframe');
for (var i = 0; i < iframes.length; i++) {
  evalIframe(iframes[i]);
}
// avalia os iframes na medida em que são inseridos na página
try {
document.addEventListener('DOMNodeInserted', function (ev) {
  // console.log("added node ", ev.target.tagName)
  if (ev.target.tagName == 'IFRAME') {
    evalIframe(ev.target);
  }
});
} catch (error) {}
`,
          }}
        />
      </>

      <ResetCSS />
    </LoadingProvider>
  );
}

export default MyApp;
